import { ensureArray } from 'utils/array';
import { ProjectService } from '../types';

type TaskTarget = {
  serviceConfigId: string;
  name: string;
  baseName: string;
};

function getTaskByService(
  serviceId: string,
  tasks: TaskTarget | TaskTarget[],
  services?: ProjectService | ProjectService[],
) {
  const fallbackService = ensureArray(services ?? []).find((s) => s.id === serviceId);

  return (
    ensureArray(tasks).find(({ serviceConfigId }) => serviceConfigId === serviceId) ?? {
      name: '#ref',
      ...fallbackService,
      baseName: fallbackService?.name ?? '#ref',
    }
  );
}

export function isTaskNameChanged(task: { name: string; baseName: string }) {
  const { baseName, name } = task;

  return name.toLowerCase() !== baseName.toLowerCase();
}

/**
 * Gets you the name of the service accounting if the task has been renamed
 *
 * Examples:
 *
 * - Task: Fieldwork, Service: Fieldwork = `Fieldwork`
 * - Task: Campo BR, Service: Fieldwork = `Fieldwork (Campo BR)`
 */
export const getServiceName = (
  serviceId: string,
  tasks: TaskTarget | TaskTarget[],
  services?: ProjectService | ProjectService[],
): string => {
  const task = getTaskByService(serviceId, tasks, services)!;

  return `${task.name}${isTaskNameChanged(task) ? ` (${task.baseName})` : ''}`;
};
